import { render, staticRenderFns } from "./ShebaKeywordsTab.vue?vue&type=template&id=2db4923e&scoped=true"
import script from "./ShebaKeywordsTab.vue?vue&type=script&lang=js"
export * from "./ShebaKeywordsTab.vue?vue&type=script&lang=js"
import style0 from "./ShebaKeywordsTab.vue?vue&type=style&index=0&id=2db4923e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db4923e",
  null
  
)

export default component.exports